import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  userNotificationPreferences: null,
  searchProfile: null,
  preferences: null,
  entryFlowParams: {
    startDate: null,
    endDate: null,
  },
  userContextMetaData: null,
}

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user;
      state.userNotificationPreferences = action.payload.userNotificationPreferences;
      state.preferences = action.payload.preferences;
      state.userContextMetaData = action.payload.userContextMetaData;
      state.redirectUrl = action.payload.redirectUrl;
      state.identification = action.payload.identification;
    },
    setData: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
    removeEntryFlowParams: (state) => {
      state.entryFlowParams = {};
    }
  }
});

export const {
  setUser,
  setData,
  removeEntryFlowParams,
} = userSlice.actions;

export const selectUser = state => state.user;

export default userSlice.reducer;
